import { render, staticRenderFns } from "./SolicitudActions.vue?vue&type=template&id=134e5637"
import script from "./SolicitudActions.vue?vue&type=script&lang=js"
export * from "./SolicitudActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports